import { httpPost, httpPostResult } from 'src/utils/cms-axios';

import { ADMIN_CONFIG_CONFLICT_CODE, AdminConfigConflictError } from './admin-config-conflict';

export { ADMIN_CONFIG_CONFLICT_CODE, AdminConfigConflictError };

// ===========================================================================
// 管理画面設定（page / site / post / post_type / post_category）の保存
// ===========================================================================
// 保存版トークン（GET の version）を base_version として送ると、サーバ
// （cms-client-admin の admin_config_version.go）は開いたときの保存版と照合し、
// 開いたあとに他の人が保存していたら何も書かずに U000132 を返す。
// 保存直前の前端の照合（config-peek.js）と、実際に書くまでの間の空きを塞ぐ。
//
// ⚠ baseVersion が undefined なら従来どおり（base_version を送らない・httpPost）。
//   GET が version を返さない旧いサーバでは前端は undefined のまま送らない。

/**
 * 設定を保存する。
 *
 * @param {string} url            /config-api 以下のパス（クエリ込み）
 * @param {object} settings
 * @param {string} siteId
 * @param {string} [baseVersion]  開いたときの保存版トークン。undefined なら照合しない
 * @returns {Promise<object>} 応答。照合したときは version（保存後のトークン）を持つ
 */
export async function saveAdminConfig(url, settings, siteId, baseVersion) {
    const headers = { 'cms-site-id': siteId };
    if (baseVersion === undefined) {
        return httpPost(url, { settings }, headers, '/config-api');
    }
    const res = await httpPostResult(
        url, { settings, base_version: baseVersion }, headers, '/config-api');
    if (res?.status === 'OK') return res;
    if (res?.error && Object.prototype.hasOwnProperty.call(res.error, ADMIN_CONFIG_CONFLICT_CODE)) {
        throw new AdminConfigConflictError(res.version);
    }
    // httpPost と同じ形で投げる（メッセージだけの Error）。
    const error = res?.error;
    const message = typeof error === 'object' && error
        ? (error.message || Object.values(error).filter(Boolean).join(' / ') || '保存に失敗しました')
        : (error || '保存に失敗しました');
    throw new Error(message);
}
